import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class FunctionDeclarationCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.FunctionDeclaration;
    }
    visitNode(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.functionLike);
    }
}

//# sourceMappingURL=FunctionDeclarationCompiler.js.map
